import { infrastructuresRepo } from '@/constants/providers';
import { AutomationKey } from '@/modules/Automations/queries/keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { AttachAutomationInfrastructureCostModel } from '../types';
import { InfrastructureCostKey } from './types';

export const useAttachAutomationInfrastructureCost = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, unknown, AttachAutomationInfrastructureCostModel>(
    (attachAutomationInfrastructureCost) =>
      infrastructuresRepo.attachAutomationInfrastructureCost(
        attachAutomationInfrastructureCost,
      ),
    {
      onError: () => {
        toast.error(t('error.associate_automation_infrastructure_cost'));
      },
      onSuccess: () => {
        toast.success(t('success_associate_automation_infrastructure_cost'));
        queryClient.invalidateQueries(AutomationKey.ALL);
        queryClient.invalidateQueries(InfrastructureCostKey.ALL);
      },
    },
  );
};
